import React, { useEffect } from 'react';
import {Routes, Route, useParams} from 'react-router-dom';
import Footer from './components/Footer';
import NavBar from './components/NavBar';
import About from './pages/About';
import Terms from './pages/Terms';
import PrivacyPolicy from './pages/PrivacyPolicy';


import 'bootstrap/dist/css/bootstrap.css';
import ContactForm from './components/ContactForm';
import Testimonials from './components/Testimonials';
import VideoListing from './components/VideoListing';
import Donate from './components/Donate';
import VideoPlayer from './components/VideoPlayer';
import { DonateApp } from './components/PaypalDonate';
import Mission from './components/Mission';

import GetInvolved from './components/GetInvolved';
import GetInvolvedDetail from './components/GetInvolvedDetail';
import FaithStatements from './components/FaithStatements';
import Leadership from './components/Leadership';
import CommunityEngagements from './components/CommunityEngagments';
import ChurchGroups from './components/ChurchGroups';
import MessageSendSuccess from './components/MessageSendSuccess';
import ChurchWebsite from './pages/ChurchWebsite';
import EventsSection from './components/EventsSection';
import TextSermonDetail from './components/TextSermonDetail';
import TextSermonList from './components/TextSermonList';
import VideoSermonList from './components/VideoSermonList';
import MinistriesSection from './components/MinistriesSection';
import SermonsSection from './components/SermonsSection';
import ChurchVolunteerOpportunites from './components/VolunteerOpportunities';
import FaqSection from './components/FaqSection';

const church = JSON.parse(localStorage.getItem('church'));


const App = () => {


  return (
    

    <>
      <NavBar/> 
     
      <Routes>
        <Route  path="/:token" element={<ChurchWebsite/>}/>
        <Route  path="/:token/about" element={<About/>}/>
        <Route  path="/:token/contact-us" element={<ContactForm/>}/>
        <Route  path="/:token/contact-us-success/:name" element={<MessageSendSuccess/>}/>
        <Route  path="/:token/events" element={<EventsSection/>}/>
        <Route  path="/:token/missions" element={<Mission/>}/>
        <Route  path="/:token/ministries" element={<MinistriesSection/>}/>
        <Route  path="/:token/get-involved" element={<GetInvolved/>}/>
        <Route  path="/:token/get-involved-detail" element={<GetInvolvedDetail/>}/>
        <Route  path="/:token/doctrines" element={<FaithStatements/>}/>
        <Route  path="/:token/leadership" element={<Leadership/>}/>
        <Route  path="/:token/faqs" element={<FaqSection/>}/>
        <Route  path="/:token/community-engagements" element={<CommunityEngagements/>}/>
        <Route  path="/:token/groups" element={<ChurchGroups/>}/>
        <Route  path="/:token/sermons" element={<VideoListing/>}/>
        <Route  path="/:token/terms" element={<Terms/>}/>
        <Route  path="/:token/privacy" element={<PrivacyPolicy/>}/>
        <Route  path="/:token/testimonies" element={<Testimonials/>}/>
        <Route  path="/:token/watch/:id" element={<VideoPlayer/>}/>
        <Route  path="/:token/donate" element={<Donate/>}/>
        <Route path="/:token/sermons" element={<SermonsSection />} />
        <Route path="/:token/volunteer-opportunites" element={<ChurchVolunteerOpportunites/>} />


        <Route path="/:token/sermons/text/:id" element={<TextSermonDetail />} />
        <Route path="/:token/sermons/text" element={<TextSermonList />} />
        <Route path="/:token/sermons/videos" element={<VideoSermonList />} />
     
        <Route  path="/:token/donate-with-paypal" element={<DonateApp/>}/>
         {/* Fallback route */}
      <Route path="/*" element={<ChurchWebsite defaultToken="demo-website" />} />







      
      </Routes>
     <Footer />
    </>
  );
};

export default App;
